/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sol_Startup_F1Inputs */

const en_mk_sol_startup_f1 = /** @type {(inputs: Mk_Sol_Startup_F1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`7 people: 3 engineering, 2 product, 2 commercial`)
};

const id_mk_sol_startup_f1 = /** @type {(inputs: Mk_Sol_Startup_F1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`7 orang: 3 teknis, 2 produk, 2 komersial`)
};

/**
* | output |
* | --- |
* | "7 people: 3 engineering, 2 product, 2 commercial" |
*
* @param {Mk_Sol_Startup_F1Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sol_startup_f1 = /** @type {((inputs?: Mk_Sol_Startup_F1Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sol_Startup_F1Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sol_startup_f1(inputs)
	return en_mk_sol_startup_f1(inputs)
});